module.exports = __webpack_public_path__ + "../static/img/firewall.aedbfa68.png";